import { useLazyQuery } from "@apollo/client/react"; 
import { Box } from '@mui/material';
import React, { useEffect } from 'react';
import { generateColumnsDefaultConfiguration } from '../../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../../components/dataGrid/DataGridGenerico';
import { GET_INDICACIONES_VISITA } from '../../../../data/graphQL/queries/MisVisitas/getIndicacionesVisita';


const IndicacionGrilla = ({ idEvaluacion }) => {

  const [getIndicacionesVisita, { data: indicaciones }] = useLazyQuery(GET_INDICACIONES_VISITA);

  useEffect(() => {
    if (!idEvaluacion) return;
    getIndicacionesVisita({ variables: { idEvaluacion } });
  }, [idEvaluacion]);

  const commonColumns = [
    {
      headerName: 'Producto',
      field: 'producto',
      flex: 2
    },
    {
      headerName: 'Cant. Diaria',
      field: 'cantidad',
      flex: 1
    },
    {
      headerName: 'Unidad',
      field: 'unidad',
      flex: 1
    }];

  const columns = generateColumnsDefaultConfiguration(commonColumns);

  return (
    <Box sx={{ margin: '0'}}>
      <Box sx={{ fontWeight: 'bold', fontSize: 12, marginBottom: '5px' }}>Indicación</Box>
      <DataGridGenerico
        columns={columns}
        rows={indicaciones?.indicacionVisita?.valorEsperado || []}
        toolbar={false}
        hideFooter />
    </Box>);

};

export default IndicacionGrilla;